import { z } from 'zod';

export const querySchema = z.object({
  channel: z.string().optional().default(''),
  target: z.string().optional().default(''),
});
